<template>
  <div class="alert alert-success">
    {{noticeMessage}}
  </div>
</template>

<script>
export default {
  props: ['noticeMessage']
}
</script>



// WEBPACK FOOTER //
// notice.vue?96e00af2